import React from 'react'
import Header from './Header.jsx'
import SectioOne from './SectioOne.jsx'
import SectionTwo from './SectionTwo.jsx'
import Footer from './Footer.jsx'


export default function Homepage() {


    return (
        <div>
            <Header/>
            <SectioOne/>
            <SectionTwo/>
            <Footer/>
        </div>
    )
}
